<template>
	<div>
		<ChangeController
			:visible="dataChanged"
			@close="show = false"
			@revert="revert"
			@save="save"
		/>

		<v-row justify="center">
			<v-col cols="6" md='12' lg='6'>
				<NewsAdmin :news='data.news' @change='dataChanged = true' />
			</v-col>
			<v-col cols="6" md='12' lg='6'>
				<v-card class="opaqueBg02 my-2" rounded elevation="10">
					<v-card-text>
						<h2 class="text-h4 mb-4">Useful Links</h2>

						<v-card rounded class="opaqueBg">
							<Collection
								:collection="data.links"
								:form="$options.LinkForm"
								@change="dataChanged = true"
								dialogWidth="600"
								title="Link"
								breakpoints="xs12"
								max-width="100%"
								itemMargin="ma-0"
								hideHelp
							>
								<LinkItem slot-scope="{ item }" v-bind="item" />
							</Collection>
						</v-card>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import NewsScraper from '@/components/admin/NewsScraper'

import Collection from '@/components/admin/ItemCollection'

import NewsAdmin from '@/components/admin/NewsAdministration'

import NewsForm from '@/components/dialogs/forms/NewsForm'
import LinkForm from '@/components/dialogs/forms/LinkForm'

import NewsItem from '@/components/n-collections/n-items/NewsItem'
import LinkItem from '@/components/n-collections/n-items/LinkItem'

import NewCard from '@/components/ui/NewCard'

export default {
	name: 'AdminHome',
	mixins: [DataMixin],
	NewsForm,
	LinkForm,
	components: {
		NewsScraper,
		Collection,
		NewsItem,
		LinkItem,
		NewCard,
		NewsAdmin
	},
	computed: {
		newsLoaded() {
			const { url, title } = this.newsLink
			return url && title
		},
	},
	methods: {
		async saveNews(post) {
			this.data.news.unshift(post)
			this.dataChanged = true
		},
	},
}
</script>

<style lang="scss" scoped>
</style>